/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import SecondaryBtn from "../../../../components/common/form/SecondaryBtn";
import { Add, Pattern } from "../../../../components/common/svg/AllSvg";
import { useEffect, useState } from "react";
import { url } from "../../../../shared/utils/url";
import useAxios from "../../../../shared/hooks/use-axios";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { dataActions } from "../../../../shared/store/data-Slice";

const Banner = ({ selectStatus, setSelectStatus, setPage }: any) => {
    const { t } = useTranslation('common');
    const lang: string = useSelector((state: any) => state.ui.lang);
    const complaintApiCall: boolean = useSelector((state: any) => state.data.complaintApiCall);
    const user: any = useSelector((state: any) => state.auth.user);
    const [result, setResult] = useState<any>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const data: any[] = [
        { id: 1, name: t("vigilance.home.banner.status.pending_review"), key: "Pending Review", status: "Pending_Review" },
        { id: 2, name: t("vigilance.home.banner.status.under_investigation"), key: "Pending Verification", status: "Pending_Verification" },
        // { id: 3, name: t("vigilance.home.banner.status.action_taken"), key: "Under Investigation", status: "Under_Investigation" },
        { id: 5, name: t("vigilance.home.banner.status.resolved"), key: "Resolved", status: "Resolved" },
    ]

    const color: any[] = [
        { css: "border-[#B20508] hover:shadow-[0_0_0_2px_#B205085e] focus:shadow-[0_0_0_2px_#B205085e] disabled:focus:shadow-none disabled:hover:shadow-none", color: "#B20508", bg: "bg-[#B20508]" },
        { css: "border-[#B2AC05] hover:shadow-[0_0_0_2px_#B2AC055e] focus:shadow-[0_0_0_2px_#B2AC055e] disabled:focus:shadow-none disabled:hover:shadow-none", color: "#B2AC05", bg: "bg-[#B2AC05]" },
        // { css: "border-secPurple hover:shadow-[0_0_0_2px_#0097D65e] focus:shadow-[0_0_0_2px_#0097D65e] disabled:focus:shadow-none disabled:hover:shadow-none", color: "#0097D6", bg: "bg-secPurple" },
        { css: "border-[#0AE194] hover:shadow-[0_0_0_2px_#0AE1945e] focus:shadow-[0_0_0_2px_#0AE1945e] disabled:focus:shadow-none disabled:hover:shadow-none", color: "#0AE194", bg: "bg-[#0AE194]" }
    ]

    const getStatistics = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.vigilance_statistics}`);

            if (res && res.status === 200) {
                setResult(res?.data)
                setLoading(false)
                dispatch(dataActions.setComplaintApiCall(false));
            }
        } catch (error) {
            dispatch(dataActions.setComplaintApiCall(false));
            console.error("error while fetching statistics", error);
        }
    }

    useEffect(() => {
        !!lang && getStatistics();
    }, [lang])

    useEffect(() => {
        complaintApiCall && getStatistics();
    }, [complaintApiCall])

    return (
        <div className="container h-full py-[25px] md:py-[40px] xlx:py-[50px] flex flex-col">
            <div className="flex items-center justify-between w-full md:flex-row flex-col gap-[15px]">
                <div className="flex flex-col gap-[2px] order-2 md:order-1 justify-start md:w-auto w-full">
                    <h2 className="text-[2.188rem] text-[#242555] font-bold uppercase">{t("vigilance.home.banner.title")}</h2>
                    <h5 className="text-[#3D3D3D] font-medium">{t("vigilance.home.banner.desc")}</h5>
                </div>

                {(user?.role === "passenger" || user?.role === "candidate" || user?.role === "Vigilance") && <div className="justify-end flex md:w-auto w-full order-1 md:order-2">
                    <SecondaryBtn title={t("grievance.home.banner.new")} css="px-[12px] xlx:px-[15px] font-bold rounded-[6px] text-sm !gap-[10px] whitespace-nowrap uppercase" leftIcon={<Add />} onClick={() => !!params?.lang ? navigate(`/${params?.lang}/register-new-complaint`) : navigate(`/register-new-complaint`)} />
                </div>}
            </div>
            {!loading && <div className="mt-[35px] grid grid-cols-1 xsm:grid-cols-2 msm:grid-cols-4 gap-[20px] xlx:gap-[25px]">
                {Array.isArray(data) && data?.map((item: any, index: number) => (
                    <button key={index} className={`${color?.[index]?.css} ${selectStatus === item?.status ? `${color?.[index]?.bg}` : "bg-white"} border w-full h-[100px] rounded-[15px] lg:rounded-[20px] py-[15px] xlx:py-[18px] px-[15px] xlsm:px-[20px] xlx:px-[24px] flex items-start justify-between gap-[15px] relative`} disabled={result[item?.key] === 0} onClick={() => {setPage(1); setSelectStatus(item?.status);}}>
                        <div className="flex flex-col justify-between h-full">
                            <h3 className={`text-[1.75rem] font-bold leading-snug text-left ${selectStatus === item?.status ? "text-white" : "text-primaryText"}`}>{!!result[item?.key] ? result[item?.key] : "0"}</h3>
                            <div className="absolute top-0 left-0 right-0 bottom-0 flex items-end justify-start py-[15px] xlx:py-[18px] px-[15px] xlsm:px-[20px] xlx:px-[24px]">
                                <h6 className={`${selectStatus === item?.status ? "text-white" : "text-blackDull"} font-bold uppercase text-left`}>{item?.name}</h6>
                            </div>
                        </div>

                        <Pattern className="min-w-[128px]" color={selectStatus === item?.status ? `white` : `${color?.[index]?.color}`} stroke={selectStatus === item?.status ? `white` : "#6E7C87"} />
                    </button>
                ))}
            </div>}
        </div>
    );
};

export default Banner;